"use client";

import { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function SuccessRateOverview({stats}) {
   
  const {
    fromMonth: savedFromMonth,
    fromYear: savedFromYear,
    toMonth: savedToMonth,
    toYear: savedToYear,
  } = useSelector((state) => state.dashboard);

  const approvedPercent = stats?.approvedVisaPercentage

  // Custom Gauge Chart data
  const createGaugeData = (value) => {
    return [{ value: value }, { value: 100 - value }];
  };
  
  function getMonthName(monthNumber) {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[monthNumber - 1] || "Invalid month";
  }

  const approvedGaugeData = createGaugeData(Number(stats?.approvedVisaPercentage || 0));   //  graph
  const rejectedGaugeData = createGaugeData(Number(stats?.rejectedVisaPercentage || 0));

  return (
    <div className="p-3 md:p-6 space-y-6 shadow-custom rounded-lg">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h1 className="text-2xl font-medium">Success Rate Overview</h1>
            <span className="text-xs text-gray-500">{getMonthName(savedFromMonth)} - {savedFromYear} - {getMonthName(savedToMonth)} - {savedToYear}</span>
        

        {/* <div className="hidden md:flex items-center gap-2">
          <span className="text-sm text-gray-500">From</span>
          <select
            className="p-2 shadow-custom rounded-md"
            value={fromMonth}
            onChange={(e) => setFromMonth(e.target.value)}
          >
            <option value="December">December</option>
          </select> 
          <select
            className="p-2 shadow-custom rounded-md"
            value={fromYear}
            onChange={(e) => setFromYear(e.target.value)}
          >
            <option value="2024">2024</option>
          </select>

          <span className="text-sm text-gray-500">To</span>
          <select
            className="p-2 shadow-custom rounded-md"
            value={toMonth}
            onChange={(e) => setToMonth(e.target.value)}
          >
            <option value="January">January</option>
          </select>
          <select
            className="p-2 shadow-custom rounded-md"
            value={toYear}
            onChange={(e) => setToYear(e.target.value)}
          >
            <option value="2025">2025</option>
          </select>
        </div> */}
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {/* Total Visa Applications */}
        <div className="p-4 bg-white rounded-lg shadow-custom">
          <div className="flex justify-between items-center pb-2">
            <span className="text-sm font-medium">Total Visa Applications</span>
            {/* <span className="text-xs text-gray-500">Dec'24 - Jan'25</span> */}
          </div>
          <div className="text-2xl font-medium">No. of {stats?.totalVisaApplications || 0}</div>
          {/* <div className="flex items-center text-sm text-green-500">
            <FaChevronUp className="mr-1" />
            +3.24%
          </div> */}
        </div>

        {/* Approved Visas */}
        <div onClick={()=>console.log(approvedPercent)} className="p-4 bg-white rounded-lg shadow-custom">
          <div className="flex justify-between items-center pb-2">
            <span className="text-sm font-medium">Approved Visas</span>
            {/* <span className="text-xs text-gray-500">Dec'24 - Jan'25</span> */}
          </div>
          <div className="text-2xl font-medium">No. of {stats?.approvedVisas || 0}</div>
          {/* <div className="flex items-center text-sm text-red-500">
            <FaChevronDown className="mr-1" />
            -1.34%
          </div> */}
        </div>

        {/* Approved Visas Chart */}
        <div className="p-4 bg-white rounded-lg ">
          <div className="text-sm font-medium pb-2">Approved Visas</div>
          <div className="h-[100px]">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={approvedGaugeData}
                  cx="50%"
                  cy="90%"
                  startAngle={180}
                  endAngle={0}
                  innerRadius={45}
                  outerRadius={68}
                  paddingAngle={0}
                  dataKey="value"
                >
                  <Cell fill="#FFA500" />
                  <Cell fill="#2F3349" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="text-center text-xl font-semibold relative -top-6">{stats?.approvedVisaPercentage || 0}%</div>
          </div>
        </div>

        {/* Rejected Visas Chart */}
        <div className="p-4 bg-white rounded-lg">
          <div className="text-sm font-medium pb-2">Rejected Visas</div>
          <div className="h-[100px]">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={rejectedGaugeData}
                  cx="50%"
                  cy="90%"
                  startAngle={180}
                  endAngle={0}
                  innerRadius={45}
                  outerRadius={68}
                  paddingAngle={0}
                  dataKey="value"
                >
                  <Cell fill="#10B981" />
                  <Cell fill="#2F3349" />
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="text-center text-xl font-semibold relative -top-6">{stats?.rejectedVisaPercentage || 0}%</div>
          </div>
        </div>
      </div>

      {/* Financial Data */}
      <div className="grid gap-6 md:grid-cols-3">
        {/* Total Net Income */}
        <div className="p-4 bg-white rounded-lg shadow-custom">
          <div className="flex justify-between items-center pb-2">
            <span className="text-sm font-medium">Total Net Income</span>
            {/* <span className="text-xs text-gray-500">Dec'24 - Jan'25</span> */}
          </div>
          <div className="text-lg md:text-2xl font-medium">${stats?.totalNetIncome || 0}</div>
          <div className="text-xs text-gray-500">+ ${stats?.netIncomeChange || 0} from last month</div>
        </div>

        {/* Received Amount */}
        <div className="p-4 bg-white rounded-lg shadow-custom">
          <div className="flex justify-between items-center pb-2">
            <span className="text-sm font-medium">Received Amount</span>
            {/* <span className="text-xs text-gray-500">Dec'24 - Jan'25</span> */}
          </div>
          <div className="text-lg md:text-2xl font-medium">${stats?.receivedAmount || 0}</div>
        </div>

        {/* Pending Amount */}
        <div className="p-4 bg-white rounded-lg shadow-custom">
          <div className="flex justify-between items-center pb-2">
            <span className="text-sm font-medium">Pending Amount</span>
            {/* <span className="text-xs text-gray-500">Dec'24 - Jan'25</span> */}
          </div>
          <div className="text-lg md:text-2xl font-medium">${stats?.pendingAmount || 0}</div>
        </div>
      </div>
    </div>
  );
}
